import {BOM} from './BOM.js';
import {track} from './TrackerWrapper.js';
import {PHONETYPE, APPID} from './config';
import {
    openUrl,
    clientLogin,
    configShareButton,
    showShareView,
    closeWebview,
    trackServer,
    trackUmeng,
    writeKeyChain
} from './client.js';

import {
    format,
    countChars,
    getUrlStrs,
    getUniversalParameters,
    getCookie,
    setCookie,
    getPosition,
    isIos,
    toTwoDigit,
    formatDate,
    getStaticData,
    translate,
    getDeviceSniffSize,
    isIphoneX,
    getAppVersion,
    getEnv,
    getLang,
    isVersionMoreThanOrEqualTo,
    kformat,
    formatInput,
    loadMedia,
    getGapTime,
    createRequestId,
    getFontSize,
    getDpr,
    insertBr,
    setTitle,
    getTextLength,
    getSize,
    windowScrollTo,
    deFormat,
    encodeSpecialHtmlChar,
    getCharSize,
    filterIdCardNumber,
    getUrlParams,
    isMobile,
    needBorderFix,
    mod,
    calculatAge,
    setStyleVariable,
    isProductionEnv,
    isSimulatorEnv,
    isFacebookApp
} from './lube/Utils.js';

import {
    getSimulatorScreen,
    getStickyBottomStyle,
    getFullScreenStyle,
    getStickyLeftStyle,
    getStickyRightStyle,
    getStickyTopStyle
} from './lube/Simulator.js';

const CACHE = {
    pokeUser: null,
    protocol: null,
    loginSatus: -1,
    h5Params: null,
    h5ParamsDict: null,
    pokeUI: null
};

function redirect(url) {
    if (isSimulatorEnv()) return;
    BOM.window.location.href = url || 'https://www.pokekara.com/download';
}

//取得当前用户信息
//http://wiki.maetime.com/pages/viewpage.action?pageId=14899143 iOS WebView 上下文设置
function getPokeUser() {
    if (CACHE.pokeUser) return CACHE.pokeUser;
    try {
        const pokeUser =
            BOM.document.pokeUser ||
            (BOM.document.pokeUser =
                (BOM.window.androidObj &&
                    BOM.window.androidObj.pokeUser &&
                    JSON.parse(BOM.window.androidObj.pokeUser())) ||
                {});
        if (!isProductionEnv() && Object.keys(pokeUser).length === 0) {
            const uid = getUrlStrs().__uid__;
            if (uid) {
                pokeUser.uid = uid;
            }
        }
        CACHE.pokeUser = pokeUser;
        return pokeUser;
    } catch (e) {
        return {};
    }
}

function getPokeUI() {
    if (CACHE.pokeUI) return CACHE.pokeUI;
    try {
        const pokeUI =
            BOM.document.pokeUI ||
            (BOM.document.pokeUI =
                (BOM.window.androidObj &&
                    BOM.window.androidObj.pokeUI &&
                    JSON.parse(BOM.window.androidObj.pokeUI())) ||
                {});
        CACHE.pokeUI = pokeUI;
        return pokeUI;
    } catch (e) {
        return {};
    }
}

//清除pokeUser 缓存
function clearPokeUserCache() {
    CACHE.pokeUser = null;
}


//是否小屏幕
function isScreenLimited(params) {
    try {
        if (params && params.screen_height) {
            const h = parseInt(params.screen_height);
            return isIos() ? h <= 480 : h <= 1184;
        } else {
            return isIos() ? BOM.window.screen.height <= 480 : BOM.window.screen.height <= 640;
        }
    } catch (e) {
        return false;
    }
}

function isScreenLimited2(params) {
    try {
        if (params && params.screen_height) {
            const h = parseInt(params.screen_height);
            return isIos() ? h <= 667 : h <= 1184;
        } else {
            return isIos() ? BOM.window.screen.height <= 667 : BOM.window.screen.height <= 640;
        }
    } catch (e) {
        return false;
    }
}

//android 版本universial link
function openAndriod(openurl, label) {
    if (isSimulatorEnv()) return;
    const re = new RegExp('universal/(.+)', 'g');
    let _openurl;
    const result = re.exec(openurl);
    if (result) {
        _openurl = result[1];
    } else {
        _openurl = 'root?tab=sing';
    }
    if (label && typeof label === 'string') {
        track(label);
    }
    window.location.href = 'pokekara://' + _openurl;
    setTimeout(function () {
        window.location.href = openurl;
    }, 2000);
}

function isLogin() {
    try {
        const pokeUser = getPokeUser();
        return pokeUser.uid ? true : false;
    } catch (e) {
        return false;
    }
}

//是否登录
function isUserLogin() {
    if (CACHE.loginSatus != -1) {
        return CACHE.loginSatus;
    }
    if (isLogin()) {
        CACHE.loginSatus = 1;
        return 1;
    }
    const env = getEnv();
    //测试环境不cache了
    if (env != 'cdn' && getUrlStrs().__uid__) {
        return 1;
    }
    CACHE.loginSatus = 0;
    return 0;
}

//线上测试域名切换
function getProtocol(env, isWeb) {
    if (CACHE.protocol) return CACHE.protocol;
    const _isWeb = isWeb || false;
    if (!_isWeb) {
        CACHE.protocol =
            env === 'cdn' ? 'https://api.pokekara.com' : 'http://test.api.pokekara.com';
    } else {
        CACHE.protocol = env === 'cdn' ? 'https://www.pokekara.com' : 'http://test.pokekara.com';
    }
    return CACHE.protocol;
}

function getLabelKey(rank) {
    if (rank > 100) {
        return -1;
    } else if (rank > 50) {
        return 5;
    } else if (rank > 20) {
        return 4;
    } else if (rank > 3) {
        return 3;
    } else if (rank > 2) {
        return 2;
    } else if (rank > 1) {
        return 1;
    } else {
        return 0;
    }
}

//是否在app内
function isNative() {
    return (
        !!(window.androidObj || (document.pokeUser && Object.keys(document.pokeUser).length > 1)) ||
        getUrlStrs().v
    );
}

//取得下一页
function getNextPageCursor(data = {}) {
    return data.pagination ? data.pagination.next_cursor_str || 0 : data.next_cursor_str || 0;
}

function getH5ParametersDict() {
    if (CACHE.h5ParamsDict) {
        return CACHE.h5ParamsDict;
    }
    const params = {...getUrlStrs()};
    !params.appid && (params.appid = APPID);
    !params.phonetype && (params.phonetype = PHONETYPE);
    params.request_refer = 'h5';
    params.request_id && delete params.request_id;
    CACHE.h5ParamsDict = params;
    return CACHE.h5ParamsDict;
}

function getH5Parameters() {
    if (CACHE.h5Params) {
        return CACHE.h5Params;
    }
    const params = getH5ParametersDict();
    CACHE.h5Params = format(params);
    return CACHE.h5Params;
}

//分享页地址
function getShareUrl(id) {
    let protocol = 'https://u.pokekara.com/';
    if (getEnv() === 'dev') {
        protocol = 'http://test.pokekara.com/';
    }
    return protocol + 'i/' + id;
}

//取得活动页得地址
function getPageUrl(projectName, pageName) {
    let url =
        'https://api.pokekara.com/webkara/static/online/cli/' +
        projectName +
        '/dist/' +
        pageName +
        '.html';
    if (getEnv() === 'dev') {
        url =
            'https://test.api.pokekara.com/webkara/static/dev/cli/' +
            projectName +
            '/dist/' +
            pageName +
            '.html';
    }
    return url;
}

//取得url参数(外部传入url)
function getUrlQueryParams(url) {
    return getUrlStrs(url);
}

//webview打开url
function openWebPage(url, params = {}) {
    if (!/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/.test(url)) {
        return;
    }
    if (isNative()) {
        openUrl('local://webview?url=' + encodeURIComponent(url) + (Object.keys(params).length > 0 ? '&' + format(params) : ''));
    } else {
        if (isSimulatorEnv()) return;
        const themeName=getUrlStrs().theme_name;
        if(themeName){
            const params=getUrlStrs(url);
            if(!params.theme_name){
                params.theme_name=themeName;
            }
            const newUrl=url.split('?')[0]+'?'+format(params);
            BOM.window.open(newUrl);
        }else {
            BOM.window.open(url);
        }

    }
}

// 获取当前的真实时间(通过app与服务器时间偏移量计算获取，近似值)
// 返回的是毫秒级时间戳
function getNowRealTime() {
    const gapTime = getPokeUser().server_time_offset || 0;
    const nowTime = new Date().getTime() - gapTime * 1000;
    return nowTime;
}

//兼容web与app的埋点
function trackServerCompatibleToWeb(data) {
    const _data = {
        event: '',
        label: '',
        value: '',
        extra: {},
        ...data
    };
    if (isNative()) {
        trackServer(_data);
    } else {
        let label = _data.label;
        for (const o in _data.extra) {
            label = label + '_' + _data.extra[o];
        }
        if (_data.value) {
            label = label + '_' + _data.value;
        }
        track(_data.event, label);
    }
}

//取得待播放的音视频地址(优先取最小)
function getMediaUrlFromMvInfo(mv_info) {
    //视频
    if (mv_info.play_type === 3) {
        const videoUrls = mv_info.video_urls;
        if (videoUrls) {
            const videoUrlList = videoUrls.filter((v) => {
                return v.definition === 6;
            });
            if (videoUrlList.length > 0) {
                return videoUrlList[0].video_url || mv_info.video_url;
            } else {
                return mv_info.video_url;
            }
        } else {
            return mv_info.video_url;
        }
    } else {
        //音频
        return mv_info.video_sound_url;
    }
}
function isLocalDev() {
    const ipPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    const hostName = BOM.window.location.hostname;
    if (hostName.indexOf('localhost') != -1 || ipPattern.test(BOM.window.location.hostname)) {
        return true;
    }
}

export {
    format,
    countChars,
    getUrlStrs,
    getUniversalParameters,
    getCookie,
    setCookie,
    getPokeUser,
    getPosition,
    isIos,
    toTwoDigit,
    formatDate,
    clientLogin,
    configShareButton,
    showShareView,
    openUrl,
    closeWebview,
    getStaticData,
    translate,
    getDeviceSniffSize,
    isScreenLimited,
    isIphoneX,
    getAppVersion,
    trackServer,
    trackUmeng,
    getEnv,
    getLang,
    openAndriod,
    isUserLogin,
    isVersionMoreThanOrEqualTo,
    getProtocol,
    writeKeyChain,
    getLabelKey,
    kformat,
    isNative,
    getNextPageCursor,
    formatInput,
    loadMedia,
    getGapTime,
    clearPokeUserCache,
    redirect,
    getH5Parameters,
    createRequestId,
    getShareUrl,
    getPageUrl,
    getFontSize,
    getDpr,
    insertBr,
    setTitle,
    getTextLength,
    getSize,
    windowScrollTo,
    deFormat,
    encodeSpecialHtmlChar,
    getCharSize,
    getH5ParametersDict,
    filterIdCardNumber,
    getUrlParams,
    isMobile,
    needBorderFix,
    mod,
    calculatAge,
    getUrlQueryParams,
    setStyleVariable,
    openWebPage,
    getNowRealTime,
    trackServerCompatibleToWeb,
    getMediaUrlFromMvInfo,
    getPokeUI,
    isProductionEnv,
    isSimulatorEnv,
    getSimulatorScreen,
    getStickyBottomStyle,
    getFullScreenStyle,
    getStickyLeftStyle,
    getStickyRightStyle,
    getStickyTopStyle,
    isFacebookApp,
    isScreenLimited2,
    isLocalDev
};
